import {getArea} from '@/api'
import Cookies from "js-cookie";
import axios from "axios";

export default {
  data() {
    return {

      goodsSource: '',                            // 用户下拉内容
      goodsTimer: '',
      goodsPage: 0,
      goodsTotal: 0,
      goodsOffset: 20,
      userSelect: false,
      goodsList: [],
      goodsFilterChantList: [],
      goodsLoading: false,

      timeEndOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      }
    }
  },
  methods: {
    handleChangeBT(daterange) {
      this.formItem.beginTime = daterange;
    },
    handleChangeBD(daterange) {
      this.formItem.beginData = daterange;
    },
    handleChangeET(daterange) {
      this.formItem.endTime = daterange;
    },
    handleChangeED(daterange) {
      this.formItem.endData = daterange;
    },
    handleChangeBDFR(daterange) {
      this.formItem.beginDataFR = daterange;
    },
    handleChangeBTFR(daterange) {
      this.formItem.beginTimeFR = daterange;
    },
    handleChangeEDFR(daterange) {
      this.formItem.endDataFR = daterange;
    },
    handleChangeETFR(daterange) {
      this.formItem.endTimeFR = daterange;
    },
    // 重置参数
    reset(val) {
      this.formItem = this.setToEmpty(Object.assign({}, val));
      this.page.page = 1;
    },
    // 重置页面
    resetPage(){
      console.log(1);
      this.page.page = 1;
    },
    // 验证手机
    validPhone(rule, value, callback) {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    },
    // 获取地址接口
    getAreaApi(item, callback) {
      let params = {index: item ? item.index : ''};

      if (item) {
        item.loading = true;
      }

      getArea(params).then(res => {
        console.log(res);
        if (res.code == 1) {
          res.result.forEach((val, ind) => {
            val.loading = false;
            val.children = [];
          });
          item.children = res.result;
        } else if (res.code == 805) {
          item.children = res.result;
        } else if (res.code == 804) {
          res.result.forEach((val, ind) => {
            val.loading = false;
            val.children = [];
          });
          this.pca = res.result;
        }

        if (callback) {
          item.loading = false;
          callback();
        }
      })
    },

    //用户列表
    // 用户过滤 || 搜索
    usersSearchs(value) {
      if (this.userSelect) return;
      if (this.formItem.name) {
        this.usersList = this.usersFilterChantList ? this.usersFilterChantList.filter(val => String(val.name).includes(value)) : [];
        this.usersTotal = this.usersList.length;
        if (!value) this.formItem.temUserNickName = '';
        return;
      }
      
      if (value != '') {
        this.usersLoading = true;
        clearTimeout(this.usersTimer);
        if (this.usersSource) this.usersSource.cancel();
        this.usersTimer = setTimeout(() => {
          this.usersSource = axios.CancelToken.source();
          axios.get(`${BaseUrl}/api-user/pc/wx_user/keyword_query`, {
            params: {
              nickName: value,
              offset: 0,
              rows: 20,
              token: JSON.parse(localStorage.getItem('baseInfo')).token
            },
            cancelToken: this.usersSource.token
          }).then(res => res.data).then(res => {
            this.usersLoading = false;
            if (res.code == 1) {
              this.usersPage += 1;
              this.usersList = res.result.list;
              this.usersFilterChantList = JSON.parse(JSON.stringify(this.usersList));
              this.usersTotal = res.result.total;
            }
          });
        }, 1000);
      } else {
        this.formItem.temCommodityId = '';
      }
    },
    // 用户选中
    usersSelects(value) {
      this.userSelect = true;
      this.formItem.temUserNickName = value;
      this.formItem.userId = this.usersList.find(val => {
        if (value == val.id) return val
      })['id'];
      this.$nextTick(() => this.userSelect = false)
    },
    // 商品下拉加载更多
    usersHandleReachBottoms(value = '') {
      return new Promise((resolve, reject) => {
        this.usersLoading = true;
        axios.get(`${BaseUrl}/api-user/pc/wx_user/keyword_query`, {
          params: {
            name: value,
            offset: this.usersPage * this.usersOffset,
            rows: 20,
            token: JSON.parse(localStorage.getItem('baseInfo')).token
          },
          cancelToken: this.usersSource.token
        }).then(res => res.data).then(res => {
          this.usersLoading = false;
          if (res.code == 1) {
            resolve();
            this.usersPage += 1;
            // this.usersList = res.result.list;
            this.usersList = this.usersList.concat(res.result.list);
            this.usersFilterChantList = JSON.parse(JSON.stringify(this.usersList));
            this.usersTotal = res.result.total;
          } else reject();
        });
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/global.js